import { render, staticRenderFns } from "./UnreadMessages.vue?vue&type=template&id=b73970e2&"
import script from "./UnreadMessages.vue?vue&type=script&lang=ts&"
export * from "./UnreadMessages.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports